import React, { FC } from "react";
import imagePng from "images/hero-right-3.png";

export interface SectionHero2Props {
  children?: React.ReactNode;
  className?: string;
}

const SectionHero2: FC<SectionHero2Props> = ({ className = "", children }) => {
  return (
    <div
      className={`nc-SectionHero2 flex flex-col-reverse lg:flex-col relative ${className}`}
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex flex-col items-start flex-shrink-0 space-y-8 lg:w-1/2 sm:space-y-10 pb-14 lg:pb-36 xl:pb-60 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-semibold text-4xl md:text-5xl xl:text-6xl !leading-[114%] ">
            The Moon Crown HAS A NEW SITE!
          </h2>
          <h3 className="font-semibold text-4xl md:text-5xl xl:text-6xl !leading-[114%] ">
            
          </h3>
          <span className="text-base md:text-2xl text-neutral-500 dark:text-neutral-400">
            Check out <a href="https://themooncrown.com">themooncrown.com</a> for more information on the show!  
          </span>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            The world is changing, bit by bit. Beasts and entities are integrated into the civilization of the new country.
          <br /> <br />{" "}
            There are signs of something young, yet somehow ancient, growing on the other side of the river.
          <br /> <br />{" "}
            Lou and her companions are on the run. She begins to send out broadcasts in hopes of reaching an audience with the truth of what really happened to get her here - and with a warning of what is coming.
          </span>
          <br /> <br />{" "}
          The Moon Crown is a full cast weird fiction horror podcast, told in found tapes and audio drama format.
          The creation, writing, sound design, voice acting for Lou, and
          this site, are done by M. Molder (trust me, the spelling is fine, I'm from an alternate universe).
        </div>
        <div className="flex-grow">
          <img className="w-6/12 mx-auto lg:w-full" src={imagePng} alt="hero" />
        </div>
      </div>
    </div>
  );
};

export default SectionHero2;
